import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useConfirmPayment from 'hooks/query/useConfirmPayment'
import { useSaveUtm } from 'hooks/query/useSaveUtm'
import { Spinner } from 'components/atom/Spinner'
import useGetBillingCustomerKey from 'hooks/query/brandpay/useGetBillingCustomerKey'
import useUserStore from 'store/useUserStore'
import usePlanStore from 'store/usePlanStore'
import useConfirmPoint from 'hooks/query/point/useConfirmPoint'
import useGetAutoChargeList from 'hooks/query/point/useGetAutoChargeList'
import classNames from 'classnames'
import { useGetPointOrderId } from 'hooks/query/point/usetGetPoinOrderId'
import { RequestPurchasePoint } from 'service/point'
import { CashPaymentModal } from 'components/payment/CashPaymentModal'
import { useGetMyPoint } from 'hooks/query/point/useGetMyPoint'
import { purchaseTrack } from 'utils/metaAd'

export const PaymentSuccess = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const userInfo = useUserStore((state: any) => state.userInfo)
  const { mutate: customerkeyMutate } = useGetBillingCustomerKey()
  const [customerKey, setCustomerKey] = useState<string>('')
  const [isBrandPaymentModal, setBrandPaymentModal] = useState<boolean>(false)

  const paymentKey = urlParams.get('paymentKey')
  const subscriptionType = urlParams.get('subscriptionType')
  const orderId = urlParams.get('orderId')
  const amount = urlParams.get('amount')
  const path = urlParams.get('path')
  const planId = urlParams.get('planId')
  const paymentType = urlParams.get('type')
  const close = urlParams.get('close')
  const selectType = urlParams.get('selectType')
  const refetch = useUserStore((state: any) => state.refetch)
  const planRefetch = usePlanStore((state: any) => state.planRefetch)

  const { data: autoChargeList, isPending } = useGetAutoChargeList()
  const { data: myPointData, refetch: getMyPointRefetch } = useGetMyPoint()
  const setPlanRefetch = usePlanStore((state: any) => state.setRefetch)
  const navigate = useNavigate()
  const { mutate: confirmPaymentMutate, isPending: planPending } =
    useConfirmPayment()
  const { mutate: confirmPointMutate, isPending: pointPending } =
    useConfirmPoint()
  const { mutate: pointOrderIdMutate } = useGetPointOrderId()

  const { mutate: saveUtmMutate } = useSaveUtm()
  const [paymentAmount, setPaymentAmount] = useState(0)
  const [autoClose, setAutoClose] = useState<string | null>(null)
  const [isCashPaymentModal, setCashPaymentModal] = useState<boolean>(false)
  const [requestPurchasePoint, setRequestPurchasePoint] =
    useState<RequestPurchasePoint>({ orderId: '' })

  const handleCashPaymentModal = () => {
    if (userInfo) {
      pointOrderIdMutate(undefined, {
        onSuccess: (data) => {
          setRequestPurchasePoint(data)
          setCashPaymentModal(true)
        },
        onError: () => {},
      })
    } else {
      navigate('/sign-up')
    }
  }

  useEffect(() => {
    if (paymentKey && orderId && amount) {
      const confirmPaymentParams = {
        paymentKey,
        orderId,
        amount: Number(amount),
      }

      if (paymentType === 'point') {
        confirmPointMutate(confirmPaymentParams, {
          onSuccess: (data: any) => {
            if (selectType === 'fashion') {
              if (window.gtag) {
                console.log('point purchase gtag send selectType fashion')
                window.gtag('event', 'conversion', {
                  send_to: 'AW-17691726853/DIoUCIv9trkbEIWoifRB',
                  value: Number(amount),
                  currency: 'KRW',
                  plan_name: '포인트 충전',
                })
              }
            } else {
              if (window.gtag) {
                console.log('point purchase gtag send selectType fastcut')
                window.gtag('event', 'conversion', {
                  send_to: 'AW-677452397/mNHDCIWZrbkbEO20hMMC',
                  value: Number(amount),
                  currency: 'KRW',
                  plan_name: '포인트 충전', // 커스텀 파라미터 추가
                })
              }
            }
            // meta pixel
            purchaseTrack({
              value: Number(amount),
              contentName: '포인트',
              contentType: 'point',
            })

            // TossPixel purchase 이벤트
            const tossPixelKey = process.env.REACT_APP_TOSS_PIXEL_KEY
            if (tossPixelKey && window.TossPixel) {
              try {
                new window.TossPixel(tossPixelKey).purchase({
                  total_price: Number(amount),
                  currency: 'KRW',
                  total_quantity: 1,
                  products: [
                    {
                      product_id: orderId,
                      category_name: '포인트',
                    },
                  ],
                })
              } catch (error) {
                console.error('TossPixel purchase failed:', error)
              }
            }
            if (close === 'null') {
              setAutoClose(null)
            } else {
              setAutoClose(close)
            }

            setPaymentAmount(Number(amount))
            navigate(`${window.location.pathname}?type=${paymentType}`, {
              replace: true,
            })
            // if (window.gtag) {
            // paymentType이 point일때  selectType(fashion/fastcut을 기준으로 나누는데 현재는 fashion인 경우만 확인하고 나머지는 fastcut으로 보내면 됌)

            // // <!-- Event snippet for 캐시충전하기 conversion page -->
            // window.gtag('event', 'conversion', {
            //   send_to: 'AW-677452397/xmAXCLLB3IwaEO20hMMC',
            //   value: Number(amount),
            //   currency: 'KRW',
            // })
            // // meta pixel
            // purchaseTrack({
            //   value: Number(amount),
            //   contentName: '포인트',
            //   contentType: 'point',
            // })
            // } else {
            //   console.error('gtag is not defined')
            // }
          },
          onError: (e: any) => {
            navigate(
              `/payment-fail?path=my-cash-dashboard&type=${paymentType}&message=${
                e?.response?.data?.message ?? ''
              }`,
            )
          },
        })
      }
      if (paymentType === 'plan') {
        confirmPaymentMutate(confirmPaymentParams, {
          onSuccess: (data) => {
            console.log('plan 결제 성공:', `plan_${planId}_${subscriptionType}`)

            if (window.gtag) {
              window.gtag('event', 'conversion', {
                send_to: 'AW-677452397/mNHDCIWZrbkbEO20hMMC',
                value: Number(amount),
                currency: 'KRW',
                transaction_id: orderId,
                plan_name: `plan_${planId}_${subscriptionType}`, // 커스텀 파라미터 추가
              })
            }

            purchaseTrack({
              value: Number(amount),
              contentName: `plan_${planId}_${subscriptionType}`,
              contentType: orderId,
            })

            // TossPixel purchase 이벤트
            const tossPixelKey = process.env.REACT_APP_TOSS_PIXEL_KEY
            if (tossPixelKey && window.TossPixel) {
              try {
                new window.TossPixel(tossPixelKey).purchase({
                  total_price: Number(amount),
                  currency: 'KRW',
                  total_quantity: 1,
                  products: [
                    {
                      product_id: orderId,
                      category_name: `plan_${planId}_${subscriptionType}`,
                    },
                  ],
                })
              } catch (error) {
                console.error('TossPixel purchase plan failed:', error)
              }
            }

            setPaymentAmount(Number(amount))

            navigate(
              `${window.location.pathname}?type=${paymentType}&planId=${planId}`,
              {
                replace: true,
              },
            )
            // if (subscriptionType === 'annual') {
            //   if (window.gtag) {
            //     if (Number(planId) === 3) {
            //       console.log('프리미엄')
            //       // <!-- Event snippet for 캐시충전하기 conversion page -->
            //       window.gtag('event', 'conversion', {
            //         send_to: 'AW-677452397/WhajCKnB3IwaEO20hMMC',
            //         value: Number(amount),
            //         currency: 'KRW',
            //       })
            //       // meta pixel
            //       purchaseTrack({
            //         value: Number(amount),
            //         contentName: '프리미엄',
            //         contentType: 'plan_3_annual',
            //       })
            //     } else if (Number(planId) === 2) {
            //       // <!-- Event snippet for 캐시충전하기 conversion page -->
            //       window.gtag('event', 'conversion', {
            //         send_to: 'AW-677452397/4xgXCKbB3IwaEO20hMMC',
            //         value: Number(amount),
            //         currency: 'KRW',
            //       })
            //       // meta pixel
            //       purchaseTrack({
            //         value: Number(amount),
            //         contentName: '프로',
            //         contentType: 'plan_2_annual',
            //       })
            //     } else if (Number(planId) === 1) {
            //       // <!-- Event snippet for 캐시충전하기 conversion page -->
            //       window.gtag('event', 'conversion', {
            //         send_to: 'AW-677452397/w5kqCKPB3IwaEO20hMMC',
            //         value: Number(amount),
            //         currency: 'KRW',
            //       })
            //       // meta pixel
            //       purchaseTrack({
            //         value: Number(amount),
            //         contentName: '라이트',
            //         contentType: 'plan_1_annual',
            //       })
            //     } else if (Number(planId) === 5) {
            //       // <!-- Event snippet for 캐시충전하기 conversion page -->
            //       window.gtag('event', 'conversion', {
            //         send_to: 'AW-677452397/lN18CPCktKobEO20hMMC',
            //         value: Number(amount),
            //         currency: 'KRW',
            //       })
            //       // meta pixel
            //       purchaseTrack({
            //         value: Number(amount),
            //         contentName: '숏폼 스페셜',
            //         contentType: 'plan_5_annual',
            //       })
            //     }
            //   } else {
            //     console.error('gtag is not defined')
            //   }
            // }
          },
          onError: (e: any) => {
            navigate(
              `/payment-fail?path=price-guide&type=${paymentType}&message=${
                e?.response?.data?.message ?? ''
              }`,
            )
          },
        })
      }
    } else if (amount) {
      alert('오류 발생 관리자에게 문의해주세요!')
      // if (subscriptionType === 'monthly') {
      //   console.log('월 구독 plan 결제 성공:', planId)
      //   if (window.gtag) {
      //     window.gtag('event', 'conversion', {
      //       send_to: 'AW-677452397/mNHDCIWZrbkbEO20hMMC',
      //       value: Number(amount),
      //       currency: 'KRW',
      //       transaction_id: orderId,
      //       plan_name: `plan_${planId}_${subscriptionType}`, // 커스텀 파라미터 추가
      //     })
      //   }

      //   purchaseTrack({
      //     value: Number(amount),
      //     contentName: `plan_${planId}_${subscriptionType}`,
      //     contentType: orderId ?? '0',
      //   })

      //   const tossPixelKey = process.env.REACT_APP_TOSS_PIXEL_KEY
      //   if (tossPixelKey && window.TossPixel) {
      //     try {
      //       new window.TossPixel(tossPixelKey).purchase({
      //         total_price: Number(amount),
      //         currency: 'KRW',
      //         total_quantity: 1,
      //         products: [
      //           {
      //             product_id: orderId,
      //             category_name: `plan_${planId}_${subscriptionType}`,
      //           },
      //         ],
      //       })
      //     } catch (error) {
      //       console.error('TossPixel purchase plan failed:', error)
      //     }
      //   }
      // }
      // setPaymentAmount(Number(amount))
      // navigate(`${window.location.pathname}?type=plan&planId=${planId}`, {
      //   replace: true,
      // })
    }
  }, [paymentKey, orderId, amount])

  useEffect(() => {
    if (planRefetch) {
      planRefetch()
    }
    if (refetch) {
      refetch()
    }
  }, [])

  useEffect(() => {
    console.log(autoClose, 'autoClose')
    if (autoClose) {
      window.close()
    }
  }, [autoClose])

  return (
    <div className="relative mx-auto my-0 flex max-w-[375px] flex-col px-[16px] md:min-h-[100vh] md:max-w-[816px]">
      <div className="flex justify-center text-[48px] font-bold">
        <p>
          {paymentType === 'plan' && Number(planId) !== 5
            ? '상품 영상 플랜 결제 완료'
            : '결제 완료'}
        </p>
      </div>
      {pointPending || planPending ? (
        <>
          {' '}
          <Spinner />
        </>
      ) : (
        <>
          <div className="mt-8 flex flex-col gap-4 rounded-[20px] bg-[#F6F8FB] px-8 py-6 font-bold">
            <div className="flex justify-between">
              <p>금액</p>
              <p>
                {Number(
                  (paymentAmount * (10 / 11)).toFixed(0),
                ).toLocaleString()}
                원
              </p>
            </div>
            <div className="flex justify-between">
              <p>VAT(부가세10%)</p>
              <p>
                {Number((paymentAmount * (1 / 11)).toFixed(0)).toLocaleString()}
                원
              </p>
            </div>
          </div>
          <div className="mt-2 flex flex-col gap-4 rounded-[20px] bg-[#AFECEC] px-8 py-5 font-bold">
            <div className="flex justify-between">
              <p>총 결제금액</p>
              <p>{paymentAmount.toLocaleString()}원</p>
            </div>
          </div>

          {paymentType === 'plan' && Number(planId) === 5 && (
            <>
              {' '}
              <div className="mt-5 flex justify-between gap-4 text-[18px] font-bold">
                <button
                  className="1 flex h-[60px] w-full items-center justify-center rounded-full bg-href text-[white]"
                  onClick={() => {
                    planRefetch()
                    refetch()
                    navigate('/video-editor')
                  }}
                >
                  상품 숏폼 영상 만들러 가기
                </button>
              </div>
            </>
          )}
          {paymentType === 'plan' && Number(planId) !== 5 && (
            <>
              <div className="mt-10 flex flex-col rounded-[20px] bg-[#F6F8FB] p-5 md:w-full md:px-[32px]">
                <div className="font-bold md:text-[24px]">
                  <p className="text-center">
                    <span className="text-[64px]">🙋🏻</span>
                    <br />
                    <span className="text-[24px] font-bold">
                      <span className="text-[#FF8800]">상품 숏폼 영상</span>도
                      만드실 계획이라면!
                    </span>{' '}
                    <br />
                    <span className="text-[18px] font-bold">
                      상품 숏폼 영상은{' '}
                      <span className="text-main">상품 영상 플랜 사용자</span>에
                      한해서{' '}
                      <span className="text-main">패스트컷 캐시를 사용</span>
                      해서 생성할 수 있어요!
                    </span>
                  </p>
                </div>

                <div className="mt-4 rounded-[10px] bg-white p-5 text-[16px] md:p-7 md:text-[18px]">
                  {autoChargeList?.chargeMap?.total?.map((el, index) => (
                    <>
                      <div className="flex items-center justify-between gap-[8px]">
                        <p className="flex items-center font-bold">
                          {Number(el.chargeAmount).toLocaleString()}캐시
                          {Number(el.chargeAmount) === 100000 && (
                            <span className="ml-1 rounded-[4px] bg-main px-1 py-0.5 text-[10px] font-bold text-white md:ml-2 md:px-3 md:py-[4px] md:text-[18px]">
                              인기
                            </span>
                          )}
                        </p>
                        {Number(el.bonusRate) > 0 && (
                          <div className="flex flex-col items-end text-[12px] md:text-[18px]">
                            <p className="font-bold">
                              {' '}
                              + {`${el.bonus.toLocaleString()}`} 캐시 보너스
                            </p>
                            <p className="text-[12px] md:text-[14px]">
                              {autoChargeList.benefitInfo
                                ?.affiliateDescription && '제휴 혜택'}
                              {autoChargeList.benefitInfo?.inviteCode &&
                                '초대 코드'}
                              {autoChargeList.benefitType === 'purchase' &&
                                '충전 혜택'}
                              {` `}
                              <span
                                className={classNames(
                                  'rounded-[4px] px-1 font-bold',
                                  {
                                    'bg-[#EEF1F7] text-error':
                                      Number(el.bonusRate) <= 9,
                                    'bg-error text-white':
                                      Number(el.bonusRate) > 9,
                                  },
                                )}
                              >
                                {`${Number(el.bonusRate).toFixed(0)}%`}
                              </span>
                            </p>
                          </div>
                        )}
                      </div>
                      {index !== autoChargeList.chargeMap.total.length - 1 && (
                        <hr className="my-[20px] h-[1px] bg-[#EEF1F7]" />
                      )}
                    </>
                  ))}
                </div>
              </div>
              <div className="mt-5 flex justify-between gap-4 text-[18px] font-bold">
                <button
                  className="1 flex h-[60px] w-[50%] items-center justify-center rounded-full bg-[#2E343D] text-[white]"
                  onClick={() => {
                    planRefetch()
                    refetch()
                    navigate('/video-editor')
                  }}
                >
                  상품 롱폼 영상 만들러 가기
                </button>
                <button
                  className="w-[50%] rounded-[40px] bg-main py-[19px] text-[18px] font-bold text-white"
                  onClick={handleCashPaymentModal}
                >
                  상품 숏폼용 캐시 충전하기
                </button>
              </div>
            </>
          )}
          <div className="mt-8 flex flex-col gap-4 font-bold text-white">
            <div className="flex w-full justify-center gap-4">
              {paymentType === 'point' && (
                <button
                  className="flex h-[60px] w-[400px] items-center justify-center rounded-full bg-[#735CFF]"
                  onClick={() => {
                    navigate('/short-video-editor')
                  }}
                >
                  컨텐츠 영상 만들러 가기
                </button>
              )}
            </div>
          </div>
        </>
      )}{' '}
      {isCashPaymentModal && (
        <CashPaymentModal
          setCashPaymentModal={setCashPaymentModal}
          userInfo={userInfo?.userInfo}
          affiliatePoint={userInfo?.affiliate?.point}
          userCurrentPoint={myPointData.totalPoint}
          requestPurchasePoint={requestPurchasePoint}
        />
      )}
    </div>
  )
}
